module.exports = "/_next/static/images/94801868e218afe1aac04a713bc66c60-roxinho-single-lg@2x.jpg.webp";